<template>
    <div>
        <section class="base-header-sec base-header-laen  laen">
            <div class="base-header__top-line laen"></div>
            <div class="container-fluid">
                <div class="   base-header__container ">
                    <div class="  d-flex justify-content-center align-items-center">
                        <h1 class="base-header__title text-center py-2">
                            <!--                            <span class="base-header__icon icon-inbox mr-3"></span>-->
                            Мој налог
                        </h1>
                    </div>
                </div>
            </div>
        </section>

        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <b-form @submit.stop.prevent="onSubmit">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Име</label>
                                <input type="text" v-model="$v.firstName.$model" class="form-control full-width"
                                    :class="{ 'is-invalid form-group--error': $v.firstName.$error }">
                            </div>
                            <div class="form-error" v-if="!$v.firstName.required">Поље је обавезно</div>

                            <div class="form-group form-group-sm">
                                <label class="form-label">Презиме</label>
                                <input type="text" v-model="$v.lastName.$model" class="form-control full-width"
                                    :class="{ 'is-invalid form-group--error': $v.lastName.$error }">
                            </div>
                            <div class="form-error" v-if="!$v.lastName.required">Поље је обавезно</div>

                            <div class="form-group form-group-sm">
                                <label class="form-label">Емаил</label>
                                <input type="text" v-model="$v.email.$model" class="form-control full-width"
                                    :class="{ 'is-invalid form-group--error': $v.email.$error }">
                            </div>
                            <div class="form-error" v-if="!$v.email.required">Поље је обавезно</div>
                            <div class="form-error" v-if="!$v.email.email">Унесите валидну емаил адресу</div>

                            <div class="form-group form-group-sm">
                                <label class="form-label">Телефон</label>
                                <input type="text" v-model="phone" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Мобилни телефон</label>
                                <input type="text" v-model="mobilePhone" class="form-control full-width">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Адреса</label>
                                <input type="text" v-model="address" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Број паралелних сесија</label>
                                <input type="text" v-model="maxNumOfConnections" disabled class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Компанија</label>
                                <input type="text" v-model="company" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Корисничко име</label>
                                <input type="text" v-model="username" disabled class="form-control full-width">
                            </div>
                        </div>

                    </div>
                    <div class="spacer20"></div>
                    <div class="d-md-flex justify-content-end align-items-center">
                        <div class="form-group form-group-sm ">
                            <button type="button" @click="update" class="btn btn-base-submit text-uppercase mr-3">
                                <!--                                <span class="icon-search mr-2"></span>-->
                                Измена
                            </button>
                            <!--                            <button type="reset" class="btn btn-base-reset text-uppercase" >-->
                            <!--                                Одустани-->
                            <!--                            </button>-->
                        </div>
                    </div>


                </b-form>
                <div v-if="successMessage" class="pt-3">
                    <b-alert show fade>{{ successMessage }}</b-alert>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
// import Vuelidate from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'


export default {
    name: "UserPage",
    data() {
        return {
            // Vuelidate: Vuelidate,

            // form: {
            address: null,
            checkPassword: null,
            company: null,
            email: null,
            firstName: null,
            lastName: null,
            maxNumOfConnections: null,
            mobilePhone: null,
            password: null,
            phone: null,
            userId: null,
            username: null,
            // },

            successMessage: null,

            // axios
            baseApiUrl: window.env.VUE_APP_API_KCPROXY_DEV,
             
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    validations: {
        firstName: { required },
        lastName: { required },
        email: { required, email },
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault();
        },
        reset() {
            this.userId = null;
            this.firstName = null;
            this.lastName = null;
            this.email = null;
            this.phone = null;
            this.mobilePhone = null;
            this.address = null;
            this.company = null;
            this.username = null;
            this.password = null;
            this.checkPassword = null;
            this.maxNumOfConnections = null;
        },
        fetchData() {
            // this.form = {


            // }

            axios.get(this.baseApiUrl + 'proxy/user')
                .then(response => {
                    console.log(response);
                    // response.data.
                    this.userId = response.data.userId;
                    this.firstName = response.data.firstName;
                    this.lastName = response.data.lastName;
                    this.email = response.data.email;
                    this.phone = response.data.phone;
                    this.mobilePhone = response.data.mobilePhone;
                    this.address = response.data.address;
                    this.company = response.data.company;
                    this.username = response.data.username;
                    this.password = null;
                    this.checkPassword = null;
                    this.maxNumOfConnections = response.data.maxNumOfConnections;
                    // this.form = response.data;
                }).catch(error => {
                    // this.reset();
                    console.log(error);
                });
        },
        update() {
            var data = {
                address: (this.address === '') ? null : this.address,
                password: (this.password === '') ? null : this.password,
                checkPassword: (this.checkPassword === '') ? null : this.checkPassword,
                company: (this.company === '') ? null : this.company,
                email: (this.email === '') ? null : this.email,
                firstName: (this.firstName === '') ? null : this.firstName,
                lastName: (this.lastName === '') ? null : this.lastName,
                maxNumOfConnections: (this.maxNumOfConnections === '') ? null : this.maxNumOfConnections,
                mobilePhone: (this.mobilePhone === '') ? null : this.mobilePhone,
                phone: (this.phone === '') ? null : this.phone,
                userId: (this.userId === '') ? null : this.userId,
                username: (this.username === '') ? null : this.username,
            };

            if (!this.$v.$invalid) {
                axios.post(this.baseApiUrl + 'proxy/editUser', data)
                    .then(response => {
                        console.log(response);
                        this.successMessage = 'Изменили сте податке на свом налогу.'
                    }).catch(error => {
                        console.log(error);
                    });
            }
        }
    },
    mounted() {
        this.fetchData();
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }
}
</script>


<style scoped></style>
